import { useMutation } from '@tanstack/react-query';
import api from '../lib/api';
import type { ApiResponse } from '../types/task';
import type {
  VoiceFeedback,
  CreateVoiceFeedbackInput,
} from '../types/voiceFeedback';

export function useCreateVoiceFeedback() {
  return useMutation({
    mutationFn: async (input: CreateVoiceFeedbackInput) => {
      const res = await api.post<ApiResponse<VoiceFeedback>>(
        '/voice-feedback',
        input,
      );
      return res.data;
    },
  });
}
